<script setup>
import 'vue3-carousel/dist/carousel.css';
import { defineProps } from 'vue';
import { onMounted } from 'vue';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

const props = defineProps({
    id: {
        type: Number,
        default: 1
    },
});

// Define your images data
let images = []

onMounted(() => {
    if (props.id == 1) {
        images = [
            { id: 1, url: 'https://soul-repository.sfo3.cdn.digitaloceanspaces.com/stories/2026-01-09/2026-01-08%20at%2018.55.12_1.jpeg' },
            { id: 2, url: 'https://soul-repository.sfo3.cdn.digitaloceanspaces.com/stories/2026-01-09/2026-01-08%20at%2018.55.12_2.jpeg' },
            { id: 3, url: 'https://soul-repository.sfo3.cdn.digitaloceanspaces.com/stories/2026-01-09/2026-01-08%20at%2018.55.12_3.jpeg' },
            { id: 4, url: 'https://soul-repository.sfo3.cdn.digitaloceanspaces.com/stories/2026-01-09/2026-01-08%20at%2018.55.12_4.jpeg' },
            { id: 5, url: 'https://soul-repository.sfo3.cdn.digitaloceanspaces.com/stories/2026-01-09/2026-01-08%20at%2018.55.12_5.jpeg' },
            { id: 6, url: 'https://soul-repository.sfo3.cdn.digitaloceanspaces.com/stories/2026-01-09/2026-01-08%20at%2018.55.12_6.jpeg' }
        ];
    } else if (props.id == 2) {
        console.log('props 2');
        images = [
            { id: 1, url: 'https://soul-repository.sfo3.cdn.digitaloceanspaces.com/stories/2026-03-18/irpf_2026.jpg' }
        ];
    }

});

// Optional: configure carousel settings
const carouselConfig = {
    itemsToShow: 1,
    wrapAround: true,
    autoplay: 3000,
};
</script>

<template>
    <div class="carousel-container">
        <Carousel v-bind="carouselConfig">
            <Slide v-for="image in images" :key="image.id">
                <img :src="image.url" alt="Imagens" class="carousel__image carousel-image" />
            </Slide>

            <template #addons>
                <Navigation />
                <Pagination />
            </template>
        </Carousel>
    </div>
</template>

<style scoped>
.carousel-container {
    max-width: 800px;
    margin: 0 auto;
}

.carousel__image {
    width: 100%;
    /* Ensures the image fits the slide width */
    height: auto;
    display: block;
    object-fit: cover;
    /* Optional: adjust how the image fits within its container */
}

.carousel__icon {
    fill: #fff;
    height: var(--vc-icn-width);
    width: var(--vc-icn-width);
}

.carousel-image {
    width: 55%;
    /* Image takes the full width of its slide container */
    height: 100%;
    /* Maintain aspect ratio */
    display: block;
    /* Helps with centering and consistent behavior */
    /* Optional: set a max-height to prevent extremely tall images on large screens */
    /* max-height: 500px; */
    object-fit: cover;
    /* or 'contain', depending on desired visual effect */
}

/* Ensure the carousel container can adapt to various screen sizes */
.carousel {
    width: 100%;
}
</style>